import { formatDate, formatStringTemplate, isDateValid } from "@civicscience/chops";

import { ErrorMessages } from "consts";

const { ErrDateCompareInvalid, ErrDateInvalid, ErrDateNotAfter, ErrDateNotBefore, ErrDateNotTodayOrFuture } =
  ErrorMessages;

const isDateAfter = (date1: Date, date2: Date): boolean => date1 > date2;
const isDateBefore = (date1: Date, date2: Date): boolean => date1 < date2;

export const validateIsDate = (dateToTest: Date): boolean | string => isDateValid(dateToTest) || ErrDateInvalid;

export const validateIsDateAfter = (date: Date, compareDate: Date): boolean | string => {
  if (!isDateValid(date) || !isDateValid(compareDate)) {
    return ErrDateCompareInvalid;
  }

  return (
    isDateAfter(date, compareDate) ||
    formatStringTemplate(ErrDateNotAfter, { afterDate: formatDate(compareDate.toDateString()) })
  );
};

export const validateIsDateBefore = (date: Date, compareDate: Date): boolean | string => {
  if (!isDateValid(date) || !isDateValid(compareDate)) {
    return ErrDateCompareInvalid;
  }

  return (
    isDateBefore(date, compareDate) ||
    formatStringTemplate(ErrDateNotBefore, { beforeDate: formatDate(compareDate.toDateString()) })
  );
};

export const validateIsDateAfterToday = (date: Date) => {
  if (!isDateValid(date)) {
    return ErrDateInvalid;
  }

  const todayDate = new Date();
  return isDateAfter(date, todayDate) || formatStringTemplate(ErrDateNotAfter, { afterDate: "today" });
};

export const validateIsDateAfterYesterday = (date: Date) => {
  if (!isDateValid(date)) {
    return ErrDateInvalid;
  }

  const yesterdayDate = new Date();
  yesterdayDate.setDate(yesterdayDate.getDate() - 1);

  return isDateAfter(date, yesterdayDate) || ErrDateNotTodayOrFuture;
};

export default {
  validateIsDate,
  validateIsDateAfter,
  validateIsDateAfterToday,
  validateIsDateAfterYesterday,
  validateIsDateBefore,
};
